import {
    DealerStep,
    DealerStepAction,
} from '../../models/osb-model/osb-dealer-step';

export const dealerStepReducer = (
    state: DealerStep,
    action: DealerStepAction
): DealerStep => {
    if (action.type === 'SET') {
        return { ...state, ...action.payload };
    }
    return state;
};
